import { usePmsConfig } from 'app/components/pms-config/usePmsConfig'
import { PmsConfigComponent } from 'app/components/pms-config/PmsConfigComponent'
import { pmsConfigValidator } from 'app/components/pms-config/pmsConfigValidator'

export default function PmsConfig() {
  const hookData = usePmsConfig()
  return <PmsConfigComponent {...hookData} validator={pmsConfigValidator} />
}
